document.addEventListener('DOMContentLoaded', function() {
        console.log("hi DOMContentLoaded");
       // if(jQuery(window).width() > 767){
       //    $('header.desktop-header.module-header').css('display', 'none')
       // }else{
       //   $('header.mobile-header.header').css('display', 'none')
       // }

    jQuery('.card-information').on('click', function(){
        var hyperlink = jQuery(this).attr('data-hyperlink')
    
        if(hyperlink){
           window.location.href = hyperlink; 
        }
    })

  jQuery('.loox-rating__main .loox-rating, .freq-bought__star-price .loox-rating').on('click', function(){
        var hyperlink = jQuery(this).parent().attr('data-hyperlink')
    
        if(hyperlink){
           window.location.href = hyperlink; 
        }
    })

    if($(location).attr('hash') == '#shopify-block-loox-product-reviews'){
        var target = $('#shopify-block-loox-product-reviews');
        $('html,body').animate({ scrollTop: target.offset().top - 250 }, 300);
    }

    if(jQuery('#sticky-add-to-cart').length) {
      const stickyBar = document.getElementById('sticky-add-to-cart');

      // Show sticky bar when scrolling down
      window.addEventListener('scroll', function () {
        const addToCartVisible = document.querySelector('.product-form__submit')?.getBoundingClientRect().top < 0;
        if (addToCartVisible) {
          stickyBar.classList.remove('hidden');
        } else {
          stickyBar.classList.add('hidden');
        }
    });
    }

   $('.cart-drawer__product--add').on('init', function (event, slick) {
      var prevButton = $('.button--slick__prev');
      prevButton.hide(); // Hide the previous button by default
  
      // Add click event handler for the previous button
      prevButton.on('click', function (e) {
          // Prevent the default behavior of the button
          e.preventDefault();
          // Go to the first slide
          $('.cart-drawer__product--add').slick('slickGoTo', 0);
          console.log("clicked");
      });
  });
  
  $('.cart-drawer__product--add').on('afterChange', function (event, slick, currentSlide) {
      var prevButton = $('.button--slick__prev');
      var nextButton = $('.slick-next');
  
      // Check if the current slide is the last slide
      if (currentSlide === slick.slideCount - 1) {
          prevButton.show(); // Show the previous button
          nextButton.hide();
      } else {
          prevButton.hide();
          nextButton.show();
      }

    prevButton.on('click', function (e) {
          // Prevent the default behavior of the button
          e.preventDefault();
          // Go to the first slide
          $('.cart-drawer__product--add').slick('slickGoTo', 0);
          console.log("clicked");
      });
    
  });

  // if($('.cart-drawer__product--add.main-cart-upsell').length){
  //   setInterval(checkslider, 1000);
  
  //   function checkslider() {
      $('.cart-drawer__product--add.main-cart-upsell').not('.slick-initialized').slick({
        infinite: false,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        adaptiveHeight: true, // Add this option to handle varying heights of slides
        focusOnSelect: true,
        responsive: [
      
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  //     console.log('Check slider checking!');
  //   }
  // }
  
  
  if($('.cart-drawer__product--add').not('.main-cart-upsell').length){

    var options = {
        infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true, // Add this option to handle varying heights of slides
      focusOnSelect: true,
      responsive: [
    
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
    }
    // $('.cart-drawer__product--add').not('.main-cart-upsell').slick(options);    
     
    $(function () {
            $('.cart-drawer__product--add').not('.main-cart-upsell').slick(options);

       $('.button--slick__prev').on('click', function (e) {
          // Prevent the default behavior of the button
          e.preventDefault();
          // Go to the first slide
          $('.cart-drawer__product--add').slick('slickGoTo', 0);
          console.log("clicked");
      });
      
        }, 100);
  
  };

   
  
     
}, true);



jQuery( window ).on( "load", function() {
      setTimeout(function(){
         jQuery('body.collection ul#gf-products li .card__information .bundleapp-compareAtPrice').prev('.price__regular').css('display', 'none')
        jQuery('body.collection ul#product-grid li .card__information .bundleapp-compareAtPrice').prev('.price__regular').css('display', 'none')
       console.log('style3000')
      }, 3000);

       setTimeout(function(){
         jQuery('body.collection ul#gf-products li .card__information .bundleapp-compareAtPrice').prev('.price__regular').css('display', 'none')
        jQuery('body.collection ul#product-grid li .card__information .bundleapp-compareAtPrice').prev('.price__regular').css('display', 'none')
       console.log('style2000')
      }, 2000);

       setTimeout(function(){
         jQuery('body.collection ul#gf-products li .card__information .bundleapp-compareAtPrice').prev('.price__regular').css('display', 'none')
        jQuery('body.collection ul#product-grid li .card__information .bundleapp-compareAtPrice').prev('.price__regular').css('display', 'none')
       console.log('style4000')
      }, 4000);

      setTimeout(function(){
        jQuery('body.collection ul#gf-products li .card__information .bundleapp-compareAtPrice').prev('.price__regular').css('display', 'none')
        jQuery('body.collection ul#product-grid li .card__information .bundleapp-compareAtPrice').prev('.price__regular').css('display', 'none')
       console.log('style5000')
      }, 5000);
} );

jQuery(window).on("load", function () {
  // if(jQuery(window).width() > 767){
  //   jQuery('header.desktop-header.module-header').css('display', 'block')
  // } else{
  //   jQuery('header.mobile-header.header').css('display', 'grid')
  // }
});

jQuery(document).ready(function(){

       
  
    // var setupTime = localStorage.getItem('setupTime');
  
    // if(jQuery('.simply-insurance .switch-button .cart-insurance-input').is(':checked')) {
    //   console.log('checked')
    //   localStorage.removeItem('setupTime');
    // }else{
    //   console.log(' not checked')

    //    if (setupTime == null) {
    //         localStorage.setItem('setupTime', new Date().getTime())
    //     } else {
    //         var intervalId = window.setInterval(function(){
              
    //         var hours = 24; // to clear the localStorage after 24-hour
    //         var now = new Date().getTime();
    //       console.log("Now: "+now)
    //         console.log((now - setupTime) +": " + " "+ (hours*60*60*1000) )
    //           console.log((now - setupTime) > (hours*60*60*1000) )
    //         if( (now - setupTime) > (hours*60*60*1000)) {
    //             localStorage.removeItem('setupTime');
    //             jQuery('.switch-button input.cart-insurance-input').trigger('click')
    //         }
    //       }, 5000);   
    //     }
    // }

    // For adding Gem-safe in the cart page

    //-------------------------------
  // Warranty Item
  //-------------------------------
  var didFind = false;
  var warrenty_removed = localStorage.getItem("warranty_item_removed");

  var check_product_shipping = false;
  // check digital products
  $.ajax({
    url: "/cart.js",
    type: "GET",
    dataType: 'json',
    contentType: 'application/json',
    success: function (data) {

      data.items.forEach(item => {
        var product_handle = item.handle;

        $.ajax({
          url: "/products/" + product_handle + ".json",
          type: "GET",
          dataType: 'json',
          contentType: 'application/json',
          success: function (data) {
            var obj = data.product.tags;
            var split_text = obj.split(", ");
            var arraycontainsdigital = (split_text.indexOf("DigitalOnly") > -1);
            console.log('is val-' + split_text);
            if (arraycontainsdigital == true) {
              check_product_shipping = true;
            } else {
              check_product_shipping = false;
              return;
            }
          }

        });
      });
    }
  });


  function addWarrantyItem() {

    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: JSON.stringify({
        quantity: 1,
        id: 40728011210891
      }),
      dataType: 'json',
      contentType: 'application/json',
      success: function (data) {
        console.log(data);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-item', cartData: data });

        window.location = '/cart';
        jQuery('.product[data-variant-id="40728011210891"]').append(`<td><a href="javascript:;" class="remove_item_Cart" data-key="">
                                                                <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                                <g id="Shelf-Cart" transform="translate(-247.000000, -23.000000)" fill="#FFFFFF">
                                                                <path d="M262.045455,23.5 L263.5,24.9545455 L256.954,31.499 L263.5,38.0454545 L262.045455,39.5 L255.5,32.954 L248.954545,39.5 L247.5,38.0454545 L254.046,31.5 L247.5,24.9545455 L248.954545,23.5 L255.5,30.045 L262.045455,23.5 Z" id="Combined-Shape"></path>
                                                                </g>
                                                                </g>
                                                                </svg>
                                                            </a></td>`);
        localStorage.setItem("warranty_item_removed", "false")
      },
      error: function (data) {
        window.alert(data.responseJSON.description);
      }
    });
  }

  // setTimeout(function () {
  if (jQuery(`.cart--columns`).length > 0) {
    $.ajax({
      url: "/cart.js",
      type: "GET",
      dataType: 'json',
      contentType: 'application/json',
      success: function (data) {
        data.items.forEach(item => {
          if (item.id == 40728011210891) {
            didFind = true
          }
        });
        console.log(check_product_shipping);



        // if (check_product_shipping == true) {

        // } else {

        if (didFind != true && warrenty_removed != "true") {
          console.log('is added true');
          addWarrantyItem();
        } else {
          jQuery('.product[data-variant-id="40728011210891"]').append(`<td><a href="javascript:;" class="remove_item_Cart" data-key="">
                                      <svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                      <g id="Shelf-Cart" transform="translate(-247.000000, -23.000000)" fill="#FFFFFF">
                                      <path d="M262.045455,23.5 L263.5,24.9545455 L256.954,31.499 L263.5,38.0454545 L262.045455,39.5 L255.5,32.954 L248.954545,39.5 L247.5,38.0454545 L254.046,31.5 L247.5,24.9545455 L248.954545,23.5 L255.5,30.045 L262.045455,23.5 Z" id="Combined-Shape"></path>
                                      </g>
                                      </g>
                                      </svg>
                                  </a></td>`)
        }
        // }
      },
      error: function (data) {
        window.alert(data.responseJSON.description);
      }
    });

    //warranty Text
    console.log('Warranty removed: ' + warrenty_removed)
    if (warrenty_removed == "true") {
      console.log("123")
      console.log($('.checkbox_grp').length);
      let check_interval = setInterval(
        function () {
          if (jQuery('.checkbox_grp').length > 0) {
            jQuery('.checkbox_grp').show();
            clearInterval(check_interval);
          }
        }
        , 10);
      // jQuery('.cart--columns').append("<div><span class='warranty_item_text'>Your order is not protected!<a  class='add_warranty_item' href='#'>Click here to add shipping insurance</a></span></div>")
    } else {
      jQuery('.warranty_item_text').hide();
    }

    //warranty add on Cart Page
    jQuery(document).on('click', '.add_warranty_item', function () { addWarrantyItem() });

    //warranty remove on Cart Page
    jQuery(document).on('click', '.remove_item_Cart', function () {
      $.ajax({
        url: "/cart/change.js",
        type: "POST",
        data: JSON.stringify({
          quantity: 0,
          id: "40728011210891"
        }),
        dataType: 'json',
        contentType: 'application/json',
        success: function (data) {
          window.location = '/cart';
          localStorage.setItem("warranty_item_removed", "true");
        },
        error: function (data) {
          window.alert(data.responseJSON.description);
        }
      });
    });
  }
  // }, 1000);
  
    // End of script adding Gem-safe in the cart page

      jQuery('#featuredProduct .awt-style-1.custom').hide();
      jQuery('#featuredProduct .product-form__buttons').hide();
    
      function waitForElement(id, callback) {
        var poops = setInterval(function () {
          if (document.getElementById('awt-product-data')) {
            clearInterval(poops);
            callback();
          }

             showProgress();  
          console.log('Waiting')
        }, 100);
      }
    
      waitForElement("idOfElementToWaitFor", function () {
        jQuery('#featuredProduct .awt-style-1.custom').show();
        jQuery('#featuredProduct .product-form__buttons').show();
        
        jQuery('input[data-variant-id="41250148319371"]').trigger('click')
        setTimeout(function () {
          jQuery('input[data-variant-id="41288592556171"]').trigger('click')
        }, 100);
    
      });

    jQuery('.minerals--tab').click(function(){
        const _tabContent = jQuery(this).data('tab');
        jQuery('.minerals--tab').removeClass('active');
        jQuery(this).addClass('active');

        jQuery('.mineral--contents').removeClass('active');
        jQuery('.' + _tabContent).addClass('active');

        jQuery('html, body').animate({
            scrollTop: jQuery('.' + _tabContent).offset().top - 30
        });
    });

    jQuery('a[href*="#"]:not([href="#"])').click(function () {
        var offset = -200; // <-- change the value here
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = jQuery(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                jQuery('html, body').animate({
                    scrollTop: target.offset().top + offset
                }, 1000);
                return false;
            }
        }
    });

    const _tabs = jQuery('.minerals--tabs');
    const _controlTabs = jQuery('.minerals--controls');

    var left = document.getElementById("tab-controls");

    if (left) {
        var footer = document.getElementsByClassName('module-footer__wrapper');
        var stop = (left.offsetTop - 60);
    
        window.onscroll = function (e) {
            var scrollTop = (scrollY !== undefined) ? scrollY : (document.documentElement || document.body.parentNode || document.body).scrollTop;
            // console.log(scrollY, left.offsetTop, footer[0].offsetTop);
            // left.offsetTop;
    
            if (scrollTop >= stop && scrollY < (footer[0].offsetTop - (window.innerHeight - 100)) && window.innerWidth > 767) {
                left.className = 'minerals--controls stick';
            } else {
                left.className = 'minerals--controls';
            }
    
        }
    }

  jQuery('li.list-social__item a').attr('target', '_blank')

  //Set active state to variants in single product page

  // if(jQuery('li.product__media-item.grid__item.slider__slide.product__media-item--variant').length > 0){
    jQuery('slider-component.thumbnail-slider li.slider__slide[data-media-position="2"]:not(.product__media-item--variant) button').trigger('click')
  // }
  
  setTimeout(function () {
    // if(jQuery('li.product__media-item.grid__item.slider__slide.product__media-item--variant').length > 0){
      jQuery('slider-component.thumbnail-slider li.slider__slide[data-media-position="2"]:not(.product__media-item--variant) button').trigger('click')
    // }
    
    jQuery('legend.form__label span').text($('input[id$="_main-1-0"]').val() + ' - ' + $('label[for$="_main-1-0"]').children('span.variant-price ').text())
  }, 500);
  
   jQuery('legend.form__label span').text(jQuery('body.product-temp-product.product .product  variant-radios fieldset.product-form__input legend.form__label').next('input').val())
   jQuery('body.product-temp-product.product .product  variant-radios fieldset.product-form__input legend.form__label').next('input').next('label').addClass('active');
  $('variant-radios .product-form__input input').on('change', function() {
      var id = $(this).attr('id');
      jQuery('label[for="'+id+'"]').addClass('active');     
      jQuery('label:not([for="'+id+'"])').removeClass('active'); 
      jQuery('legend.form__label span').text($(this).val() + ' - ' + $(this).next('label.active').children('span.variant-price ').text())

  });

  //   jQuery('.quantity__button').on('click', function(){
  //     setTimeout(function() { 
  //         window.location.reload()
  //     }, 500);
     
  // })
  
  
}); 


